import LoaderIcon from "../assets/preloader-puf.svg?react";
import styles from "./PageLoader.module.scss";

export const PageLoader = () => (
    <div className={styles.wrapper}>
        <div className={styles.container}>
            <div className={styles.box}>
                <LoaderIcon className={styles.icon} />
            </div>
        </div>
    </div>
);
